import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/categories/${id}`)
                    .then((res) => {
                        resolve(res.data.data.category);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create({}, categoryForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/categories", categoryForm)
                    .then((res) => {
                        resolve(res.data.data.category);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({}, categoryForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/categories/${categoryForm.get("id")}`, categoryForm)
                    .then((res) => {
                        resolve(res.data.data.category);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({}, categoryId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/categories/${categoryId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore({}, categoryId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/categories/${categoryId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getMasterList({}, categoryId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/categories/master-list`, {
                        params: {
                            category_id: categoryId,
                        },
                    })
                    .then((res) => {
                        resolve(res.data.data.datas);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getSubCategories({}, categoryId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/categories/${categoryId}/get-sub-categories`)
                    .then((res) => {
                        resolve(res.data.data.sub_categories);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
